import React from "react";
import { Reorder } from 'framer-motion';
import { matchPhrases } from "../../../utils/utilities";

import AccordionItem from "../custom-visual-inspection/accordion-item";
import CustomNewItem from '../custom-general/custom-new-item';
import ItemCount from '../../blocks/item-count';
import ReorderItem from '../../common/reorderItem';
import ThreatAnalysisForm, { AnalysisItem } from '../../forms/custom-cdr/threatAnalysis';

import toastService from "../../../services/toastService";

interface Props {
    analysisItems: AnalysisItem[];
    onChangeAnalysisItems: (items: AnalysisItem[]) => void;
}

const ThreatAnalysisEvaluationItems: React.FC<Props> = ({ analysisItems, onChangeAnalysisItems }) => {
    const handleAddAnalysisItem = (item: AnalysisItem) => {
        const itemMatch = analysisItems.find((analysisItem) => matchPhrases(analysisItem.cdrNumber, item.cdrNumber));
        if (itemMatch) return toastService.error(`CDR Number ${item.cdrNumber} already exists!`);

        const newAnalysisItems = [...analysisItems, item];
        onChangeAnalysisItems(newAnalysisItems);
    };

    const handleDeleteAnalysisItem = (item: AnalysisItem) => {
        const newAnalysisItems = analysisItems.filter((analysis) => analysis.cdrNumber !== item.cdrNumber);
        onChangeAnalysisItems(newAnalysisItems);
    };
   
    const handleEditAnalysisItem = (baseItem: AnalysisItem, updatedItem: AnalysisItem) => {
        const newAnalysisItems = analysisItems.map((analysis) => analysis.cdrNumber === baseItem.cdrNumber ? updatedItem : analysis);
        onChangeAnalysisItems(newAnalysisItems);
    };

    return ( 
        <>
            <ItemCount count={analysisItems.length} label='Threat Analysis Items' />
                            
            <CustomNewItem label='Add New Threat Analysis'>
                <ThreatAnalysisForm onSave={handleAddAnalysisItem} />
            </CustomNewItem>
            
            <Reorder.Group className="list-unstyled" values={analysisItems} onReorder={onChangeAnalysisItems}>
                {analysisItems.map((item) => (
                    <ReorderItem key={item.cdrNumber} value={item}>
                        <AccordionItem title={item.cdrNumber} isActive>
                            <ThreatAnalysisForm
                                analysisItem={item}
                                onSave={(updated: AnalysisItem) => handleEditAnalysisItem(item, updated)}
                                onDelete={() => handleDeleteAnalysisItem(item)}
                            />
                        </AccordionItem>
                    </ReorderItem>
                ))}
            </Reorder.Group>
        </>
     );
};
 
export default ThreatAnalysisEvaluationItems;